import React from "react";
import "../filter-modals.css";
import { AiOutlineCloseCircle } from "react-icons/ai";

const AllIncentiveFilter = ({
  display,
  setDisplay,
  setStatFilters,
  runIncentivesData,
  statFiltersRaw,
  fetchIncentives,
}) => {
  if (!display) return;
  return (
    <div className="absolute-filter-modal-container">
      <div className="close-filter-modal">
        <p className="small boldText">Date</p>
        <AiOutlineCloseCircle
          onClick={(e) => {
            e.stopPropagation();
            setDisplay(false);
          }}
          className="cursor"
          size={20}
          color="#34204C"
        />
      </div>

      <div className="absolute-filter-modal-body">
        <div className="absolute-filter-modal-start">
          <p
            className="small removemargin cursor"
            onClick={(e) => {
              e.stopPropagation();
              runIncentivesData(null, null, false, true);
            }}
          >
            Today
          </p>
          <p
            className="small removemargin cursor"
            onClick={(e) => {
              e.stopPropagation();
              runIncentivesData(null, null, true, false);
            }}
          >
            Yesterday
          </p>
        </div>

        <div className="absolute-filter-modal-date">
          <div>
            <p className="xsmall removemargin">From</p>
            <input
              className="absolute-filter-date-in"
              type="date"
              value={statFiltersRaw?.incentives?.from}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => {
                setStatFilters((p) => ({
                  incentives: {
                    ...p.incentives,
                    from: e.target.value,
                  },
                }));
              }}
            />
          </div>
          <div>
            <p className="xsmall removemargin">To</p>
            <input
              className="absolute-filter-date-in"
              type="date"
              value={statFiltersRaw?.incentives?.to}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => {
                setStatFilters((p) => ({
                  incentives: {
                    ...p.incentives,
                    to: e.target.value,
                  },
                }));
              }}
            />
          </div>
        </div>

        <div className="absolute-filter-modal-actions">
          <p
            className="small removemargin cursor"
            onClick={() => {
              setStatFilters((p) => ({
                incentives: {
                  from: "",
                  to: "",
                },
              }));
              fetchIncentives();
            }}
          >
            Clear
          </p>
          <button
            className="themeBtn"
            onClick={(e) => {
              e.stopPropagation();
              runIncentivesData(statFiltersRaw?.incentives?.from, statFiltersRaw?.incentives?.to);
            }}
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default AllIncentiveFilter;
